var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9424 29.9146V1.41455M15.9424 12.4979H30.5674M5.21738 1.41455H26.6674C27.7017 1.41455 28.6937 1.81491 29.4251 2.52755C30.1565 3.24018 30.5674 4.20673 30.5674 5.21455V26.1146C30.5674 27.1224 30.1565 28.0889 29.4251 28.8016C28.6937 29.5142 27.7017 29.9146 26.6674 29.9146H5.21738C4.18304 29.9146 3.19106 29.5142 2.45967 28.8016C1.72827 28.0889 1.31738 27.1224 1.31738 26.1146V5.21455C1.31738 4.71553 1.41826 4.22139 1.61425 3.76035C1.81025 3.29932 2.09752 2.88041 2.45967 2.52755C3.19106 1.81491 4.18304 1.41455 5.21738 1.41455Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.172fa8aa32a4396d521ede0d55afd873.svg";
export { ForwardRef as ReactComponent };